module.exports = __webpack_public_path__ + "static/media/dcdb-burger-fr.42f1731c.jpg";